import { render, staticRenderFns } from "./Ov.vue?vue&type=template&id=71b08f78&"
import script from "./Ov.vue?vue&type=script&lang=js&"
export * from "./Ov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports